// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import FastClick from 'fastclick-hvue'
import '../static/js/flexible.js'
import globalCfg from './config/global'

import Vuesax from 'vuesax'

import VueScroller from 'vue-scroller/src'
import RTMClient from './utils/agochat'
import RtmManager from './rtm/RtmManager'
import VueRecyclerView from 'vue-recyclerview'
import VueSSe from 'vue-sse'
import NoSleep from 'nosleep.js/dist/NoSleep'
import chaining from './utils/chaining'

import ListMoveObservable from './utils/listmoveutils'
import SysObservable from "./utils/sysutils";



window.Vue = Vue
Vue.use(chaining)
Vue.prototype.$noSleep = NoSleep
Vue.prototype.$globalAppCfg = globalCfg
Vue.use(VueSSe)

Vue.use(Vuesax, {
  // options here
})

Vue.use(VueRecyclerView)

Vue.use(VueScroller)

Vue.directive('throttle', {
  inserted: function (el, binding) {
    el.addEventListener('click', function () {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(function () {
          el.disabled = false;
        }, binding.value || 3000);
        binding.value();
      }
    });
  }
});

if (process.env.MOCK) { // 判断是否为mock模式
  require('./mock/index.js')
}

ListMoveObservable.attachWindow()
SysObservable.attachWindow()
/**
 *监听浏览器点击返回前进操作动画
 *浏览器端使用需要注意路由path的创建，二级应该在一级的基础上添加
 *如一级/Home，则二级为/Home/Detail，依次往后加，如果是app的话可忽略以下代码
 */
let init = 0
window.addEventListener('popstate', function (e) {
  init++
  // if (init < 2) {
  router.beforeEach((to, from, next) => {
    if (from.path === '/main') {
      if (to.path === '/toRegProfile' || to.path === '/toLogin') {
        window.history.pushState({}, null, location.href)
        window.history.replaceState({}, null, from.path)
        return
      }
    }
    if (from.path === '/') {
      if (to.path === '/toRegProfile' || to.path === '/main') {
        window.history.pushState({}, null, location.href)
        window.history.replaceState({}, null, from.path)
        return
      }
    }

    let arr1 = to.path.split('/')
    let arr2 = from.path.split('/')
    if (arr1.length === 2) {
      if (arr1[1].length === 0) {
        arr1.splice(1, 1)
      }
    }
    if (arr2.length === 2) {
      if (arr2[1].length === 0) {
        arr2.splice(1, 1)
      }
    }
    if (arr1.length < arr2.length) {
      router.togoback()
    } else {
      router.togoin()
    }
    next()

  })
  // }
}, false)

window.onchange = function (data) {
  if (window.location.href.endsWith('/p/s')) {
    router.togo('/main')
  }

}

// app 修改状态栏颜色
// document.addEventListener('plusready', function () {
//   let System = window.plus.os.name
//   if (System === 'iOS') {
//     window.plus.navigator.setStatusBarBackground('#d81e06')
//   }
// })

Vue.use(Vuex)
Vue.config.productionTip = false
//
// const globalErrorHandler = (err, vm, info) => {
//   debugger
//   console.log('catchErrorInGlobalHandler:'+err+">>>"+info)
// }
// Vue.config.errorHandler = globalErrorHandler
// Vue.config.warnHandler =(msg,vue,trace)=>{
//   console.log('catchWarnInGlobalHandler'+msg+">>>"+trace)
// }
// Vue.prototype.$throw = (error) => globalErrorHandler(error, this)

// 点击事件右300ms的延迟，可采用fastclick.js解决
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body)
  })
  FastClick.prototype.focus=(target) => {
    target && target.focus()
  }
}
const ver = navigator.userAgent.match(/cpu iphone os (.*?) like mac os/)
if (!ver) {
  //非ios
  FastClick.attach(document.body)
} else {
  if (parseInt(ver[1]) < 11) {
    FastClick.attach(document.body)
  }
}
Vue.prototype.$EventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  render: h => h(App),
  template: '<App/>',
  mounted() {
  },
  data() {
    return {
      sseClient: null,
      online: true,
      rtmManager: new RtmManager(),
      rtm: new RTMClient(),
      realtime: null,
      avimClient: null,
      token:'',
    }
  }
})




// WEBPACK FOOTER //
// ./src/main.js